<!--
 * @Description: 附件预览（美化版）
 * @Author: PF
 * @Date: 2023-12-11 10:41:28
 * @LastEditors: PF
 * @LastEditTime: 2026-09-02 16:46:56
-->
<template>
  <el-dialog
    class="preview-dialog wp80 hp80"
    :model-value="openDetail"
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
    destroy-on-close
    align-center
  >
    <template #header>
      <div class="pv-header">
        <div class="pv-header__left">
          <div class="pv-logo">
            <el-icon><Document /></el-icon>
          </div>
          <span class="pv-title">附件预览</span>
          <span class="pv-sub">共 {{ listFj.length }} 个文件</span>
        </div>
        <div class="pv-header__right">
          <el-tooltip :content="asideShow ? '收起列表' : '展开列表'" placement="bottom">
            <el-button text circle @click="asideShow = !asideShow">
              <el-icon><component :is="asideShow ? 'Fold' : 'Expand'" /></el-icon>
            </el-button>
          </el-tooltip>
          <el-button text circle class="pv-close" @click="closeWindow('openDetail', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </div>
    </template>

    <el-container class="pv-body">
      <!-- 预览区 -->
      <el-main class="pv-main">
        <div class="pv-stage" :class="{ 'pv-stage--dark': curMeta.dark }">
          <div
            v-loading="loading"
            element-loading-text="文件加载中…"
            element-loading-background="rgba(255, 255, 255, .72)"
            class="pv-board"
            :class="{ 'pv-board--dark': curMeta.dark }"
          >
            <!-- 悬浮工具条 -->
            <div v-if="canOperate" class="pv-tools">
              <el-tooltip content="放大" placement="bottom">
                <el-button text circle :disabled="scale >= 5" @click="zoom(0.2)"><el-icon><ZoomIn /></el-icon></el-button>
              </el-tooltip>
              <el-tooltip content="缩小" placement="bottom">
                <el-button text circle :disabled="scale <= 0.2" @click="zoom(-0.2)"><el-icon><ZoomOut /></el-icon></el-button>
              </el-tooltip>
              <span class="pv-scale">{{ Math.round(scale * 100) }}%</span>
              <el-divider direction="vertical" />
              <el-tooltip content="旋转" placement="bottom">
                <el-button text circle @click="rotateRight"><el-icon><RefreshRight /></el-icon></el-button>
              </el-tooltip>
              <el-tooltip content="还原" placement="bottom">
                <el-button text circle @click="resetTransform"><el-icon><RefreshLeft /></el-icon></el-button>
              </el-tooltip>
            </div>

            <!-- PDF -->
            <embed
              v-if="kind === 'pdf'"
              class="pv-fill pv-bg-light"
              :src="fileUrl"
              type="application/pdf"
            />

            <!-- 视频 -->
            <video
              v-else-if="kind === 'video'"
              class="pv-fill"
              controls
              autoplay
              playsinline
            >
              <source :src="fileUrl" :type="videoMime">
            </video>

            <!-- 图片 -->
            <img
              v-else-if="kind === 'image'"
              class="pv-img"
              :src="fileUrl"
              :style="imgStyle"
              draggable="false"
              @load="officeJiaZai"
              @wheel.prevent="onWheel"
            />

            <!-- 文本 / 代码类 -->
            <iframe
              v-else-if="kind === 'text'"
              class="pv-fill pv-bg-light"
              :src="fileUrl"
              frameborder="0"
            />

            <!-- Office：仅支持 docx / xlsx -->
            <vue-office-docx
              v-else-if="isDocx"
              class="pv-fill pv-bg-light"
              :src="fileUrl"
              @rendered="officeJiaZai"
              @error="officeJiaZai"
            />
            <vue-office-excel
              v-else-if="isXlsx"
              class="pv-fill pv-bg-light"
              :src="fileUrl"
              @rendered="officeJiaZai"
              @error="officeJiaZai"
            />

            <!-- 空 / 不支持 -->
            <div v-else class="pv-empty">
              <div class="pv-empty__icon" :style="{ background: curMeta.color }">
                <el-icon><component :is="curMeta.icon" /></el-icon>
              </div>
              <p class="pv-empty__title">{{ dqwj.fj ? '该文件格式暂不支持在线预览' : '暂无可预览的文件' }}</p>
              <p class="pv-empty__desc">{{ dqwj.fj ? '你可以下载到本地后查看' : '请在右侧选择一个附件' }}</p>
              <el-button v-if="dqwj.fj" type="primary" round @click="downloadFile(dqwj)">
                <el-icon><Download /></el-icon>下载文件
              </el-button>
            </div>
          </div>
        </div>
      </el-main>

      <!-- 附件列表 -->
      <el-aside v-if="asideShow && listFj.length" class="pv-aside" width="264px">
        <div class="pv-aside__title">
          <span>文件列表</span>
          <el-tag type="info" size="small" round effect="plain">{{ listFj.length }}</el-tag>
        </div>
        <div class="pv-aside__search">
          <el-input v-model="keyword" size="small" clearable placeholder="搜索文件名">
            <template #prefix><el-icon><Search /></el-icon></template>
          </el-input>
        </div>
        <el-scrollbar class="pv-aside__scroll">
          <div
            v-for="(item, index) in filterList"
            :key="item.fj + index"
            class="pv-file"
            :class="{ 'is-active': curFile === item.__index }"
            @click="wjClick(item, item.__index)"
          >
            <span class="pv-file__index">{{ item.__index + 1 }}</span>
            <div class="pv-file__icon" :style="{ background: metaOf(item.wjlx).color }">
              <el-icon><component :is="metaOf(item.wjlx).icon" /></el-icon>
            </div>
            <div class="pv-file__meta">
              <div class="pv-file__name" :title="item.ymc">{{ item.ymc }}</div>
              <div class="pv-file__sub">
                <span class="pv-file__type">{{ metaOf(item.wjlx).label }}</span>
                <span class="pv-file__dot">·</span>
                <span>{{ index + 1 }} / {{ filterList.length }}</span>
              </div>
            </div>
            <el-tooltip content="下载" placement="top">
              <el-button class="pv-file__down" text circle size="small" @click.stop="downloadFile(item)">
                <el-icon><Download /></el-icon>
              </el-button>
            </el-tooltip>
          </div>
          <el-empty v-if="!filterList.length" description="未匹配到文件" :image-size="70" />
        </el-scrollbar>
      </el-aside>
    </el-container>

    <!-- 底部信息栏 -->
    <div class="pv-footer">
      <div class="pv-footer__info">
        <div class="pv-footer__name" :title="dqwj.ymc">{{ dqwj.ymc || '未选择文件' }}</div>
        <div class="pv-footer__count">
          第 <b>{{ listFj.length ? curFile + 1 : 0 }}</b> / {{ listFj.length }} 个
        </div>
      </div>
      <div class="pv-footer__actions">
        <el-button-group>
          <el-button :disabled="curFile <= 0" @click="step(-1)"><el-icon><ArrowLeft /></el-icon>上一个</el-button>
          <el-button :disabled="curFile >= listFj.length - 1" @click="step(1)">
            下一个<el-icon><ArrowRight /></el-icon>
          </el-button>
        </el-button-group>
        <el-button type="primary" :disabled="!dqwj.fj" @click="downloadFile(dqwj)">
          <el-icon><Download /></el-icon>下载
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { closeWindow } from '@/api/common.js'
import { download } from '@/utils/requestDownload.js'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'
import {
  Document, Close, Download, Picture, VideoCamera, Tickets, Files, FolderOpened,
  ArrowLeft, ArrowRight, ZoomIn, ZoomOut, RefreshLeft, RefreshRight, Search
} from '@element-plus/icons-vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false, default: () => ({}) }
})
const emits = defineEmits(['update:openDetail'])

/* ---------- 文件类型元信息 ---------- */
const EXT_KIND = {
  pdf: 'pdf',
  docx: 'word',
  doc: 'word',
  xlsx: 'excel',
  xls: 'excel',
  txt: 'text',
  log: 'text',
  md: 'text',
  csv: 'text',
  json: 'text',
  xml: 'text',
  mp4: 'video',
  webm: 'video',
  ogg: 'video',
  mov: 'video',
  '3gp': 'video',
  png: 'image',
  jpg: 'image',
  jpeg: 'image',
  gif: 'image',
  svg: 'image',
  webp: 'image',
  bmp: 'image'
}
const KIND_META = {
  pdf: { icon: 'Document', color: 'linear-gradient(135deg,#ff6b6b,#e74c3c)', label: 'PDF', dark: false },
  word: { icon: 'Document', color: 'linear-gradient(135deg,#5b8def,#2b579a)', label: 'WORD', dark: false },
  excel: { icon: 'Tickets', color: 'linear-gradient(135deg,#42b883,#217346)', label: 'EXCEL', dark: false },
  text: { icon: 'Files', color: 'linear-gradient(135deg,#b0b6bf,#8c8c8c)', label: 'TEXT', dark: false },
  video: { icon: 'VideoCamera', color: 'linear-gradient(135deg,#9d6bff,#722ed1)', label: 'VIDEO', dark: true },
  image: { icon: 'Picture', color: 'linear-gradient(135deg,#3fd0c9,#13c2c2)', label: 'IMAGE', dark: true },
  other: { icon: 'FolderOpened', color: 'linear-gradient(135deg,#c9ccd4,#a8adb8)', label: 'FILE', dark: false }
}
const kindOf = ext => EXT_KIND[String(ext || '').toLowerCase()] || 'other'
const metaOf = ext => KIND_META[kindOf(ext)]

/* ---------- 状态 ---------- */
const baseurl = ref('')
const listFj = ref([])
const dqwj = ref({})
const curFile = ref(0)
const loading = ref(false)
const asideShow = ref(true)
const keyword = ref('')

const fileUrl = computed(() => (dqwj.value.fj ? baseurl.value + dqwj.value.fj : ''))
const kind = computed(() => kindOf(dqwj.value.wjlx))
const curMeta = computed(() => metaOf(dqwj.value.wjlx))
const ext = computed(() => String(dqwj.value.wjlx || '').toLowerCase())
const isDocx = computed(() => ext.value === 'docx')
const isXlsx = computed(() => ext.value === 'xlsx')
const canOperate = computed(() => kind.value === 'image')
const videoMime = computed(() => (ext.value === '3gp' ? 'video/3gpp' : `video/${ext.value}`))
const filterList = computed(() => {
  const kw = keyword.value.trim().toLowerCase()
  return listFj.value
    .map((item, i) => ({ ...item, __index: i }))
    .filter(i => !kw || String(i.ymc).toLowerCase().includes(kw))
})

/* ---------- 图片缩放 / 旋转 ---------- */
const scale = ref(1)
const rotate = ref(0)
const imgStyle = computed(() => ({
  transform: `scale(${scale.value}) rotate(${rotate.value}deg)`,
  cursor: 'grab'
}))
const zoom = delta => (scale.value = +Math.min(5, Math.max(0.2, scale.value + delta)).toFixed(2))
const rotateRight = () => (rotate.value = (rotate.value + 90) % 360)
const resetTransform = () => { scale.value = 1; rotate.value = 0 }
const onWheel = e => { e.deltaY < 0 ? zoom(0.15) : zoom(-0.15) }

/* ---------- 行为 ---------- */
const officeJiaZai = () => { loading.value = false }

const wjClick = (item, index) => {
  if (index === curFile.value && dqwj.value.fj === item.fj) return
  resetTransform()
  curFile.value = index
  dqwj.value = { wjlx: '', fj: '' }
  loading.value = ['docx', 'xlsx'].includes(String(item.wjlx).toLowerCase())
  dqwj.value = item
}
const step = delta => {
  const next = curFile.value + delta
  if (next >= 0 && next < listFj.value.length) wjClick(listFj.value[next], next)
}
const downloadFile = item => {
  if (!item || !item.fj) return
  download(baseurl.value + item.fj, item.ymc)
}
const onKeydown = e => {
  if (!props.openDetail) return
  if (e.key === 'Escape') closeWindow('openDetail', emits, false)
  if (e.key === 'ArrowLeft') step(-1)
  if (e.key === 'ArrowRight') step(1)
}
onMounted(() => window.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown))

watch(
  () => props.openDetail,
  open => {
    if (!open) return
    baseurl.value = process.env.VUE_APP_BASE_API
    keyword.value = ''
    resetTransform()
    curFile.value = 0
    listFj.value = (props.row?.listFj || []).map(item => ({
      ...item,
      wjlx: String(item.fj).substring(item.fj.lastIndexOf('.') + 1),
      ymc: String(item.fj).substr(item.fj.lastIndexOf('/') + 1)
    }))
    dqwj.value = listFj.value[0] || {}
    loading.value = ['docx', 'xlsx'].includes(ext.value)
  },
  { immediate: true }
)
</script>

<style lang="less" scoped>
@primary: #4f7cff;

/* ---------- 头部 ---------- */
.pv-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  width: 100%;
  padding: 0 14px 0 20px;
  border-bottom: 1px solid #eef0f4;
  background: #fff;
  &__left { display: flex; align-items: center; gap: 10px; }
  &__right { display: flex; align-items: center; gap: 4px; }
}
.pv-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  font-size: 16px;
  color: #fff;
  border-radius: 9px;
  background: linear-gradient(135deg, @primary, #7b5cff);
  box-shadow: 0 6px 14px rgba(79, 124, 255, .35);
}
.pv-title { font-size: 16px; font-weight: 600; color: #1f2329; }
.pv-sub { padding: 2px 9px; font-size: 12px; color: #8a9099; background: #f4f5f7; border-radius: 10px; }
.pv-close:hover { color: #f56c6c; background: #fef0f0; }

/* ---------- 主体 ---------- */
.pv-body { height: calc(100% - 60px); }
.pv-main { padding: 0; overflow: hidden; }
.pv-stage {
  height: 100%;
  padding: 16px;
  background: #f5f6f8;
  transition: background .25s;
  &--dark { background: radial-gradient(circle at 50% 0%, #353b47, #1e2128 70%); }
}
.pv-board {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 26px rgba(15, 23, 42, .08);
  &--dark { background: transparent; box-shadow: none; }
}
.pv-fill { display: block; width: 100%; height: 100%; border: 0; }
.pv-bg-light { background: #fff; }
.pv-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  user-select: none;
  transition: transform .18s ease-out;
}

/* 悬浮工具条 */
.pv-tools {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  background: rgba(255, 255, 255, .94);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .14);
  backdrop-filter: blur(6px);
  opacity: 0;
  transform: translateY(-6px);
  pointer-events: none;
  transition: all .2s ease;
  .el-button + .el-button { margin-left: 0; }
}
.pv-board:hover .pv-tools { opacity: 1; transform: none; pointer-events: auto; }
.pv-scale { min-width: 46px; font-size: 12px; color: #6b7280; text-align: center; }

/* 空状态 */
.pv-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 6px;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    margin-bottom: 6px;
    font-size: 28px;
    color: #fff;
    border-radius: 18px;
    box-shadow: 0 10px 22px rgba(15, 23, 42, .18);
  }
  &__title { margin: 0; font-size: 15px; font-weight: 600; color: #303133; }
  &__desc { margin: 0 0 8px; font-size: 13px; color: #909399; }
}

/* ---------- 右侧列表 ---------- */
.pv-aside {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-left: 1px solid #eef0f4;
  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 8px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }
  &__search { padding: 0 16px 10px; }
  &__scroll { flex: 1; padding: 0 10px 12px; }
}
.pv-file {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  margin-bottom: 6px;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: all .18s ease;
  &:hover { background: #f6f8fc; }
  &.is-active {
    background: linear-gradient(90deg, rgba(79, 124, 255, .12), rgba(79, 124, 255, .04));
    border-color: rgba(79, 124, 255, .35);
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 12%;
      width: 3px;
      height: 76%;
      background: @primary;
      border-radius: 0 3px 3px 0;
    }
  }
  &__index {
    flex: none;
    width: 20px;
    font-size: 12px;
    font-weight: 700;
    color: #b6bcc7;
    text-align: center;
  }
  &.is-active &__index { color: @primary; }
  &__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 15px;
    color: #fff;
    border-radius: 8px;
  }
  &__meta { flex: 1; min-width: 0; }
  &__name {
    overflow: hidden;
    font-size: 13px;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.is-active &__name { color: @primary; font-weight: 600; }
  &__sub { margin-top: 2px; font-size: 11px; color: #a8adb8; }
  &__type { color: #8a9099; }
  &__dot { margin: 0 4px; }
  &__down { opacity: 0; transition: opacity .18s; }
  &:hover &__down { opacity: 1; }
}

/* ---------- 底部 ---------- */
.pv-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 20px;
  background: #fff;
  border-top: 1px solid #eef0f4;
  &__info { min-width: 0; }
  &__name {
    overflow: hidden;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__count { margin-top: 2px; font-size: 12px; color: #909399; b { color: @primary; } }
  &__actions { display: flex; flex: none; gap: 10px; }
}
</style>
